import {
    routes
} from '@/components/router'

export const global = {
    namespaced: true,
    state: () => ({
        // 缓存的路由
        cachedRoute: [],
        // 允许的导航菜单项
        menuPermitted: [],
        // 导航菜单是否收缩
        menuCollapse: false,
        // loading-global当前状态
        loadingGlobalStatus: '',
        // loading当前状态
        loadingStatus: '',
        // 状态栏气泡文本，格式为 [文本, 颜色]
        headerRemindText: []
    }),
    getters: {
        // 获取允许的路由
        getRoutesPermitted(state) {
            return routes.map((s) => {
                if (s.children) {
                    let _s = { ...s}
                    _s.children = _s.children.filter((_s0) => state.menuPermitted.includes(_s0.meta.routeName))
                    return _s
                }
                return s
            }).filter((s) => s.children ? s.children.length : state.menuPermitted.includes(s.meta.routeName))
        },
        // 获取缓存的路由路径
        getCachedRoutePath(state) {
            let o = state.cachedRoute.map((s) => s.meta.cachedName).flat()
            o.push('others')
            return o
        }
    },
    mutations: {
        setCachedRoute(state, value) {
            if (!state.cachedRoute.find((s) => s.meta.cachedName === value.meta.cachedName)) {
                state.cachedRoute.unshift(value)
            }
            if (state.cachedRoute.length > 5) {
                state.cachedRoute.pop()
            }
        },
        unsetCachedRoute(state, value) {
            state.cachedRoute = state.cachedRoute.filter((s) => s.meta.cachedName !== value.meta.cachedName)
        },
        setMenuPermitted(state, value) {
            state.menuPermitted = value
        },
        setMenuCollapse(state) {
            state.menuCollapse = !state.menuCollapse
        },
        setLoadingGlobal(state, value) {
            state.loadingGlobalStatus = value
        },
        setLoading(state, value) {
            state.loadingStatus = value
        },
        setHeaderRemindText(state, value) {
            state.headerRemindText = value || []
        }
    }
}
